// import Navbar from "./Navbar";
import React, { useState, useEffect } from "react";
import { MdPageview } from "react-icons/md";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
import axios from "axios";
// import "./Listings.css";
// import ReactPaginate from "react-paginate";

import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FaImages } from "react-icons/fa";
import "./Directory.css";
import ReactPaginate from "react-paginate";

function Add_Category1() {
  const [dataSource, setdataSource] = useState([]);
  const formdata = new FormData();

  useEffect(() => {
    AllPartners();
  }, []);

  const AllPartners = async () => {
    let res = await axios.get("https://maargdarshak.in/api/user/getCategory1");
    if (res.status === 200) {
      // console.log(res);
      setdataSource(res.data.Category1Info);
    }
  };

  const [CategoryName, setcategory] = useState();
  const [Category1Name, setCategoryImage] = useState();
  const [show, setshow] = useState(false);

  const handleClose = () => {
    setshow(false);
  };

  const [dataSource1, setdataSource1] = useState([]);

  useEffect(() => {
    AllPartners1();
  }, []);

  const AllPartners1 = async () => {
    let res = await axios.get("https://maargdarshak.in/api/user/getCategory");
    if (res.status === 200) {
      // console.log(res);
      setdataSource1(res.data.CategoryInfo);
    }
  };

  const AddCategory = async (e) => {
    e.preventDefault();
    if (!CategoryName) {
      alert("Please Enter Category Name");
      return;
    }

    formdata.append("CategoryName", CategoryName.toUpperCase());
    formdata.append("SubcategoryName", Category1Name.toUpperCase());

    try {
      const config = {
        url: "/user/addCategory1",
        method: "post",
        baseURL: "https://maargdarshak.in/api",
        hearder: { "content-type": "application/json" },

        data: formdata,
      };
      await axios(config).then(function (res) {
        if (res.status === 200) {
          // console.log(res.data);
          alert("Sub-Category Added");
          setshow(false);
          setcategory();
          setCategoryImage();
          AllPartners();
        } else {
          alert("Something Wrong");
        }
      });
    } catch (error) {
      console.log(error.response);
    }
  };

  const [pageNumber, setPageNumber] = useState(0);

  const usersPerPage = 3;
  const pagesVisited = pageNumber * usersPerPage;
  const pageCount = Math.ceil(dataSource.length / usersPerPage);
  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };

  return (
    <div style={{ backgroundColor: "#f3f3f9", paddingBottom: "100px" }}>
      {/* <Navbar /> */}
      <div style={{ padding: "1% 2%" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            padding: "10px 20px 0px 20px",
          }}
        >
          <h6
            style={{
              fontSize: "16px",
              fontWeight: "bold",
            }}
          >
            SUB-CATEGORY
          </h6>
          <button
            style={{
              backgroundColor: "#ff7d26",
              color: "white",
              fontWeight: "600",
              fontSize: "14px",
              padding: "10px 10px",
              borderRadius: "20px",
            }}
            onClick={() => setshow(true)}
          >
            +ADD SUB-CATEGORY
          </button>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="EloetableOrder">
              <div class="card-body">
                <div class="table-responsive">
                  <div class="react-bootstrap-table">
                    <table
                      class="table table align-middle table-nowrap"
                      style={{ width: "96%", margin: "2%" }}
                    >
                      <thead
                        style={{ backgroundColor: "#ff7d26", color: "white" }}
                      >
                        <tr style={{ padding: "10px", textAlign: "center" }}>
                          <th
                            tabindex="0"
                            aria-label="Phone / Email sortable"
                            class="sortable"
                          >
                            CATEGORY NAME{" "}
                            <span class="order">
                              <span class="dropdown">
                                <span class="caret"></span>
                              </span>
                              <span class="dropup">
                                <span class="caret"></span>
                              </span>
                            </span>
                          </th>

                          <th>SUB-CATEGORY NAME</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataSource
                          .slice(pagesVisited, pagesVisited + usersPerPage)
                          .map((item) => {
                            return (
                              <tr
                                style={{
                                  textAlign: "center",
                                }}
                              >
                                <td>{item.CategoryName}</td>
                                <td>{item.SubcategoryName}</td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                </div>
                <Modal
                  show={show}
                  onHide={handleClose}
                  animation={true}
                  style={{ marginTop: "5%" }}
                >
                  <Modal.Header></Modal.Header>
                  <div class="col-md-12" style={{ margin: "2% 4%" }}>
                    <select
                      style={{
                        width: "90%",
                        padding: "10px 10px",
                        border: "1px solid #ff7d26",
                        marginBottom: "2%",
                      }}
                      onChange={(e) => {
                        setcategory(e.target.value);
                      }}
                    >
                      <option>Select Category</option>
                      {dataSource1.map((item) => {
                        return (
                          <option value={item.CategoryName}>
                            {item.CategoryName}
                          </option>
                        );
                      })}
                    </select>

                    <label
                      style={{
                        textAlign: "left",
                        paddingBottom: "10px",
                        fontSize: "22px",
                        color: "#ff7d26",
                        fontWeight: "500",
                      }}
                    >
                      Enter Sub-Category{" "}
                    </label>
                    <br></br>
                    <input
                      type="text"
                      placeholder="Sub-Category here..."
                      style={{
                        padding: "10px",
                        width: "90%",
                        border: "1px solid #ff7d26",
                      }}
                      value={Category1Name}
                      onChange={(e) => {
                        setCategoryImage(e.target.value);
                      }}
                    />
                    {/* <button
              style={{
                padding: "10px",
                color: "white",
                backgroundColor: "#ff7d26",
                border: "none",
              }}
              onClick={addcategory}
            >
              Add Category
            </button> */}
                  </div>

                  <Modal.Footer
                    style={{
                      justifyContent: "space-between",
                      padding: "10px 20px",
                    }}
                  >
                    <Button
                      style={{
                        backgroundColor: "#ffcc33",
                        border: "none",
                        width: "120px",
                      }}
                      onClick={handleClose}
                    >
                      CANCEL
                    </Button>

                    <Button
                      style={{
                        backgroundColor: "#ff7d26",
                        border: "none",
                        width: "180px",
                      }}
                      onClick={AddCategory}
                    >
                      ADD CATEGORY
                    </Button>
                  </Modal.Footer>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReactPaginate
        previousLabel={"<"}
        nextLabel={">"}
        pageCount={pageCount}
        onPageChange={changePage}
        containerClassName={"paginationBttns"}
        previousLinkClassName={"previousBttn"}
        nextLinkClassName={"nextBttn"}
        disabledClassName={"paginationDisabled"}
        activeClassName={"paginationActive"}
      />
    </div>
  );
}

export default Add_Category1;
